/**
 * Barème des paliers de recherche — MIROIR de `ConstructionRules` (backend).
 * Le NIVEAU de bâtiment requis est la source de vérité ; le PALIER en est déduit
 * par la courbe triangulaire inverse (purement cosmétique : regroupement d'arbre).
 *
 * Tiers : T1=niv 1 · T2=2-3 · T3=4-6 · T4=7-10 · T5=11-15.
 */

/** Plafond global de niveau des bâtiments (= niveau requis max d'une recherche). */
export const MAX_BUILDING_LEVEL = 15;

/** Palier d'un niveau requis : plus petit P tel que P×(P+1)/2 ≥ niveau. 0 si ≤0. */
export function tierForLevel(level: number): number {
  if (level <= 0) return 0;
  let p = 1;
  while ((p * (p + 1)) / 2 < level) p++;
  return p;
}

/** Niveau le plus BAS du palier (1, 2, 4, 7, 11…). */
export function firstLevelOfTier(tier: number): number {
  return tier <= 0 ? 0 : ((tier - 1) * tier) / 2 + 1;
}

/** Niveau le plus HAUT du palier (1, 3, 6, 10, 15…). */
export function lastLevelOfTier(tier: number): number {
  return tier <= 0 ? 0 : (tier * (tier + 1)) / 2;
}

/** Liste des niveaux d'un palier, plafonnée à `cap` (défaut MAX_BUILDING_LEVEL). */
export function levelsOfTier(tier: number, cap: number = MAX_BUILDING_LEVEL): number[] {
  const lo = firstLevelOfTier(tier);
  const hi = Math.min(cap, lastLevelOfTier(tier));
  const out: number[] = [];
  for (let l = lo; l <= hi; l++) out.push(l);
  return out;
}
